import { inject, injectable } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { SettingsRouter } from '../../../settings/types';
import { modules } from '../../modules';

@injectable()
export class SettingsRouterService implements SettingsRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToMainSettings() {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/event-types`,
    );
  }

  goToCompanyStructure(id: string) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.company.basename
      }/${id}/structure`,
    );
  }

  goToCompanyProfilesEdit(id: string) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.company.basename
      }/${id}/profiles/edit`,
    );
  }

  goBack(prevState: { pathname: string; search: string }) {
    this.history.push(prevState);
  }

  goToCompanySettings() {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.company.basename
      }`,
    );
  }

  goToCompanyAccessProfiles(id: string) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.company.basename
      }/${id}/access-profiles`,
    );
  }

  goToCompanyAccessProfilesSetup(id: string) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.company.basename
      }/${id}/access-profiles/setup`,
    );
  }

  goToEditCompanyTimezone(id: string) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.company.basename
      }/${id}/timezone/edit`,
    );
  }

  goToCreateCompanyTimezoneException(id: string) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.company.basename
      }/${id}/timezone/exception/create`,
    );
  }

  goToCompanyTimezone(id: string) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.company.basename
      }/${id}/timezone`,
    );
  }
}
